import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteInstitute } from '../hooks/useDeleteInstitute';
import type { InstituteListItem } from '../types/institute.types';

interface InstituteDeleteConfirmationProps {
  institute: InstituteListItem | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function InstituteDeleteConfirmation({
  institute,
  open,
  onOpenChange,
}: InstituteDeleteConfirmationProps) {
  const { mutate, isPending } = useDeleteInstitute();

  function handleConfirm() {
    if (!institute) return;
    mutate(institute.id, { onSuccess: () => onOpenChange(false) });
  }

  const description = institute
    ? `"${institute.name}" will be permanently removed. This action cannot be undone.`
    : '';

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete institute?"
      description={description}
      confirmLabel="Delete"
      confirmVariant="destructive"
      isPending={isPending}
      pendingLabel="Deleting..."
      onConfirm={handleConfirm}
    />
  );
}
